/* Reorder the native contact payload without intercepting submission or removing CRM fields. */
(function () {
  var form = document.getElementById('commission-form');
  if (!form) return;
  form.addEventListener('formdata', function (event) {
    var data = event.formData;
    var original = Array.from(data.entries());
    function value(label) { return String(data.get('contact[' + label + ']') || '').trim(); }
    var range = value('Budget range USD');
    var budget = range ? (/^Not sure/i.test(range) ? range : range + ' USD') : 'Not provided';
    if (/Corporate/i.test(value('Build type')) && range && !/^Not sure/i.test(range)) budget += ' per watch';
    var chosenCountry = value('Customer country');
    var provenance = value('Specification provenance');
    var specifications = /^No technical specifications chosen/.test(provenance)
      ? 'Not selected — requesting Namir’s guidance.'
      : (value('Starting point') !== 'Described in message' ? 'Starting point: ' + value('Starting point') + '. See specification details below; defaults are identified.' : 'See chosen specifications below; defaults are identified.');
    var primaryNames = ['name', 'email', 'Instagram handle', 'Phone', 'Best times to call', 'Call consent', 'Build type', 'Purchase timing', 'Customer country', 'Quantity', 'Preferred completion date', 'Required date or occasion', 'Donor watch or sourcing request', 'body'];
    var primary = primaryNames.map(function (name) { return 'contact[' + name + ']'; });
    var system = original.filter(function (pair) { return !/^contact\[/.test(pair[0]); });
    var ordered = system.slice();
    function originalField(name) {
      original.forEach(function (pair) { if (pair[0] === 'contact[' + name + ']') ordered.push(pair); });
    }
    originalField('name');
    originalField('email');
    if (value('Instagram handle')) originalField('Instagram handle');
    originalField('Phone');
    originalField('Best times to call');
    originalField('Call consent');
    originalField('Build type');
    ordered.push(['contact[Budget]', budget]);
    originalField('Purchase timing');
    originalField('Customer country');
    originalField('Quantity');
    originalField('Preferred completion date');
    originalField('Required date or occasion');
    originalField('Donor watch or sourcing request');
    originalField('body');
    ordered.push(['contact[Specifications]', specifications]);
    ordered.push(['contact[Technical reference]', 'CRM and attribution details below. No action needed on these fields.' + (chosenCountry ? ' Use Customer Country above (' + chosenCountry + ') for the customer’s stated location; Shopify’s automatic Country Code can differ.' : ' Shopify’s automatic Country Code is not a confirmed customer location.')]);
    // Retain exact original keys, values and multiplicity for importer compatibility and native CAPTCHA.
    original.forEach(function (pair) {
      if (/^contact\[/.test(pair[0]) && primary.indexOf(pair[0]) === -1) ordered.push(pair);
    });
    Array.from(new Set(original.map(function (pair) { return pair[0]; }))).forEach(function (key) { data.delete(key); });
    ordered.forEach(function (pair) { data.append(pair[0], pair[1]); });
  });
})();
